import { useQuery } from '@tanstack/react-query';
import { fetchPeopleTicketsAccess } from '../../services/peopleTicketsApi';
import type { PeopleTicketsAccess } from '../../types/peopleTickets';

/**
 * Whether this person gets the new ticketing pages. The pilot gate lives in the PROXY
 * (PEOPLE_TICKETS_LIVE / PEOPLE_TICKETS_PILOT_EMAILS), so cutover needs no frontend release:
 * the moment the proxy says `enabled`, Ticket Management and My Inquiries switch over.
 *
 * A failed read is treated as NOT enabled — the old pages still work, so falling back to them
 * is the safe direction; the reverse would show an empty new page to someone mid-cutover.
 */
export function usePeopleTicketsAccess(): { access: PeopleTicketsAccess | null; loading: boolean } {
  const query = useQuery({
    queryKey: ['people-tickets-access'],
    queryFn: fetchPeopleTicketsAccess,
    staleTime: 5 * 60_000,
    retry: 1,
  });
  return { access: query.isError ? null : (query.data ?? null), loading: query.isLoading };
}
